/* Maison du Booster : extrait de snippets/mdb-ux-recherche.liquid (23/09, charge en defer) */
  (function () {
    var CLE = 'mdb-recherches-recentes', MAX = 5;
    function lire() {
      try {
        var v = JSON.parse(localStorage.getItem(CLE) || '[]');
        return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x.trim(); }).slice(0, MAX) : [];
      } catch (e) { return []; }
    }
    function ecrire(l) { try { localStorage.setItem(CLE, JSON.stringify(l)); } catch (e) {} }
    function norm(s) {
      s = String(s || '');
      try { s = s.normalize('NFD').replace(/\p{Diacritic}/gu, ''); } catch (e) {}
      return s.toLowerCase().replace(/\s+/g, ' ').trim();
    }
    function ajouter(t) {
      t = String(t || '').replace(/\s+/g, ' ').trim();
      if (t.length < 2 || t.length > 60 || t.indexOf(':') !== -1) return;
      var n = norm(t);
      var l = lire().filter(function (x) { return norm(x) !== n; });
      l.unshift(t);
      ecrire(l.slice(0, MAX));
    }
    var LOUPE = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 7.5V12l3 2"/></svg>';
    function remplir() {
      var blocs = document.querySelectorAll('[data-mdb-recents]');
      if (!blocs.length) return;
      var l = lire();
      var sig = l.join('\u0001');
      blocs.forEach(function (bloc) {
        var ul = bloc.querySelector('[data-mdb-recents-liste]');
        if (!ul) return;
        if (!(ul.getAttribute('data-sig') === sig && ul.children.length === l.length)) {
          ul.textContent = '';
          l.forEach(function (t) {
            var li = document.createElement('li');
            li.setAttribute('ref', 'resultsItems[]');
            var a = document.createElement('a');
            a.className = 'mdb-rp-puce mdb-rp-puce--recent';
            a.href = '/search?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last';
            a.innerHTML = LOUPE;
            var s = document.createElement('span');
            s.textContent = t;
            a.appendChild(s);
            li.appendChild(a);
            ul.appendChild(li);
          });
          ul.setAttribute('data-sig', sig);
        }
        if (bloc.hidden !== !l.length) bloc.hidden = !l.length;
      });
    }
    function champ() { return document.querySelector('#search-modal input[name="q"]'); }

    document.addEventListener('click', function (e) {
      var cible = e.target instanceof Element ? e.target : null;
      if (!cible) return;
      /* effacer l'historique : liste videe tout de suite, focus rendu au champ */
      if (cible.closest('[data-mdb-recents-effacer]')) {
        e.preventDefault();
        ecrire([]);
        remplir();
        var c = champ(); if (c) c.focus();
        return;
      }
      /* clic sur un resultat de la fenetre : on retient ce qui a ete tape */
      var lien = cible.closest('#search-modal .predictive-search-form__content a[href]');
      if (lien) {
        var q = champ();
        if (q && q.value.trim().length >= 2) ajouter(q.value);
        return;
      }
      /* « Rechercher » dans le menu mobile : fermer le tiroir puis ouvrir la fenetre de recherche */
      var btn = cible.closest('[data-mdb-menu-recherche]');
      if (btn) {
        e.preventDefault();
        var tiroir = btn.closest('header-drawer');
        var details = tiroir && tiroir.querySelector('details.menu-drawer-container');
        var modale = document.getElementById('search-modal');
        if (tiroir && typeof tiroir.close === 'function') tiroir.close();
        var debut = Date.now();
        (function attendre() {
          /* le tiroir retire son piege a focus a la fin de sa fermeture : on ouvre la fenetre juste apres */
          if (details && details.hasAttribute('open') && Date.now() - debut < 800) return requestAnimationFrame(attendre);
          if (modale && typeof modale.showDialog === 'function') modale.showDialog();
        })();
      }
    }, true);

    function demarrer() {
      /* page de recherche : on retient la requete si elle a donne des resultats */
      if (typeof window.MDB_RECHERCHE_TERMES === 'string' && document.querySelector('#ResultsList .product-grid__item, .mdb-rs-pages')) {
        /* search.terms arrive echappe (« d&#39;élite ») : on le decode avant de le retenir */
        var tx = document.createElement('textarea');
        tx.innerHTML = window.MDB_RECHERCHE_TERMES;
        ajouter(tx.value);
      }
      remplir();
      var zone = document.querySelector('#search-modal .predictive-search-form__content');
      var dialogue = document.querySelector('#search-modal dialog');
      if (zone && 'MutationObserver' in window) {
        new MutationObserver(function () {
          remplir();
          /* telephone : c'est la fenetre elle-meme qui defile ; de nouveaux resultats repartent du haut */
          var q = champ();
          if (dialogue && q && document.activeElement === q && dialogue.scrollTop) dialogue.scrollTop = 0;
        }).observe(zone, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
    else demarrer();
  })();
